import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthService } from './auth.service';
import { Globals } from '../shared/globals';
import { StationOwnerHistory } from '../models/station-owner-history.model';
import { DriverHistory } from '../models/driver-history.model';
import { JsonSerializer } from 'typescript-json-serializer';

@Injectable()
export class HistoryService {
  private stationOwnerLastHistoryUrl: string;
  private driverHistoryUrl: string;
  private jsonSerializer = new JsonSerializer();

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private globals: Globals
  ) {
    this.stationOwnerLastHistoryUrl = globals.apiUrl('StationOwnerLastHistory');
    this.driverHistoryUrl = globals.apiUrl(
      'Chargings/History?from={from}&to={to}&type=driver'
    );
  }

  getLastStationOwnerHistoryItems(): Promise<StationOwnerHistory[]> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;
        return this.http
          .get(this.stationOwnerLastHistoryUrl, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: basicToken,
            },
          })
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err;
          });
      })
      .catch((err) => {
        Promise.reject();
      });
  }

  getDriverHistory(from: Date, to: Date): Promise<DriverHistory[]> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;
        return this.http
          .get(
            this.driverHistoryUrl
              .replace('{from}', (from.getTime() / 1000).toString())
              .replace('{to}', (to.getTime() / 1000).toString()),
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: basicToken,
              },
            }
          )
          .toPromise()
          .then((response) => {1
            return Object.keys(response).map((item) =>
              this.jsonSerializer.deserializeObject<DriverHistory>(response[item], DriverHistory)
            );
          })
          .catch((err) => {
            return err;
          });
      })
      .catch((err) => {
        Promise.reject();
      });
  }
}
